import { createTranslations } from '@npco/utils-translations'

export const introStageTranslations = createTranslations({
  title: 'Introducing Zeller Savings Account',
  titleMarch: 'Triple your interest with Zeller Savings Account',
})
